// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ReactLenis } from '@studio-freight/react-lenis'; // <-- 1. IMPORT LENIS

// Import Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PhoneMockup from './components/PhoneMockup';
import LogoCarousel from './components/LogoCarousel';
import Services from './components/Services';
import Strategy from './components/Strategy';
import Projects from './components/Projects';
// import Contact from './components/Contact';
import Footer from './components/Footer';

function Home() {
    return (
        <>
            <Hero />
            <About />
            <Services />
            <Projects />
            <PhoneMockup />
            <LogoCarousel />
            <Strategy />
            {/*<Contact />*/}
        </>
    );
}

function App() {

    // 2. CONFIGURE LENIS OPTIONS
    const lenisOptions = {
        lerp: 0.08,           // Controls the smoothness (0.05 - 0.2 is a good range)
        duration: 1.5,        // Animation duration for scroll-to events
        smoothTouch: false,   // **IMPORTANT** -> PRESERVES NATIVE TOUCH BEHAVIOR FOR MOBILE
        smoothWheel: true,    // Enables smooth scrolling for mouse wheels
    };

    return (
        <Router>
            {/* 3. WRAP YOUR ENTIRE PAGE LAYOUT IN ReactLenis */}
            {/* The 'root' prop makes it control the main browser scrollbar */}
            <ReactLenis root options={lenisOptions}>
                <div className="min-h-screen bg-light text-dark font-sans">
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </ReactLenis>
        </Router>
    );
}

export default App;